/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
import $ from 'jquery';
import countdown from '../../../../plugins/countdown';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

window.countdown = countdown;

const template = ({ days, hours, minutes, seconds, nfs_id }) => `
  <div class="d-flex text-center justify-content-center align-content-center">
    <div class="">
      <div class="countdown">
        <div class="countdown__number">${days?.value}</div>
        <svg>
            <circle r="18" cx="20" cy="20" style="stroke: #e60019;stroke-dashoffset: ${113 * (((days?.duration - days?.value) / days?.duration))}px; stroke-dasharray: ${'113'}px"></circle>
        </svg>
      </div>
      <div class="countdown__label">Days</div>
    </div>

    <div class="">
      <div class="countdown">
        <div class="countdown__number">${hours?.value}</div>
        <svg>
            <circle r="18" cx="20" cy="20" style="stroke: #e60019;stroke-dashoffset: ${113 * (((hours?.duration - hours?.value) / hours?.duration))}px; stroke-dasharray: ${'113'}px"></circle>
        </svg>
      </div>
      <div class="countdown__label">Hours</div>
    </div>

    <div class="">
      <div class="countdown">
        <div class="countdown__number">${minutes?.value}</div>
        <svg>
            <circle r="18" cx="20" cy="20" style="stroke: #ffab00;stroke-dashoffset: ${113 * (((minutes?.duration - minutes?.value) / minutes?.duration))}px; stroke-dasharray: ${'113'}px"></circle>
        </svg>
      </div>
      <div class="countdown__label">Minutes</div>
    </div>

    <div class="">
      <div class="countdown">
        <div class="countdown__number">${seconds?.value}</div>
        <svg>
            <circle r="18" cx="20" cy="20" style="stroke: #2470b8;stroke-dashoffset: ${113 * (((seconds?.duration - seconds?.value) / seconds?.duration))}px; stroke-dasharray: ${'113'}px"></circle>
        </svg>
      </div>
      <div class="countdown__label">Seconds</div>
    </div>
  </div>
  ${nfs_id ? `<div class="js-submit-stop-training btn-stop-training" data-id="${nfs_id}">Stop</div>` : ''}
`;


const templateSingle = ({ time, duration, nfs_id }) => `
  <div class="d-flex text-center justify-content-center align-content-center">
    <div class="">
      <div class="countdown single">
        <div class="countdown__number" style="font-size: 11px;">In Progress</div>
        <svg>
            <circle r="18" cx="20" cy="20" style="stroke: #2470b8;stroke-dashoffset: ${113 * (((duration - time) / duration))}px; stroke-dasharray: ${'113'}px"></circle>
        </svg>
      </div>
    </div>
  </div>
  ${nfs_id ? `<div class="js-submit-stop-training btn-stop-training" data-id="${nfs_id}">Stop</div>` : ''}
`;

export default () => {
  $('.js-countdown').each((i, element) => {
    const $target = $(element);
    // let countdown = $target.data('duration');
    // const duration = $target.data('duration');
    const type = $target.data('type');
    const endDate = $target.data('end-date');
    const startDate = $target.data('start-date');
    const nfs_id = $target.data('id');
    const generation = $target.data('generation');
    const endDatetime = new Date(new Date(endDate * 1000));
    const value = endDate - startDate;
    const days = Math.round(Math.floor(value / (60 * 1000) / 60) / 24);
    $target.attr('title', `Claim Date: ${(endDatetime).toLocaleString()}`);

    if (type === 'single') {
      const timer = countdown(
        endDatetime,
        (ts) => {
          const render = templateSingle({ time: ts.seconds, duration: value, nfs_id });
          $target.html(render);

          if (ts.value >= 0) {
            // clearInterval(timer);
            $target.html(`
            <div class="text-center">
                <button class="default-button js-claim-player" data-id="${nfs_id}" data-generation="${generation}" data-wallet-type="nfsg">
                 <span>Claim</span>
                </button>
            </div>
            `);
          }
        },
        countdown.SECONDS,
      );
    } else {
      const timer = countdown(
        endDatetime,
        (ts) => {
          const time = ((ts.seconds * 60) + (ts.minutes * 60) + (ts.hours * 60)) * 100;
          const render = template({
            nfs_id,
            seconds: { value: ts.seconds, duration: 60 },
            minutes: { value: ts.minutes, duration: 60 },
            hours: { value: ts.hours, duration: 24 },
            days: { value: ts.days, duration: days },
          });
          $target.html(render);

          if (ts.value >= 0) {
            // clearInterval(timer);
            $target.html(`
            <div class="text-center">
                <button class="default-button js-claim-player" data-id="${nfs_id}" data-generation="${generation}" data-wallet-type="nfsg">
                  <span>Claim</span>
                </button>
            </div>
            `);
          }
        },
        countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
      );
    }

    const cvcTip = tippy($target.get(0), {
      content: $target.attr('title'),
      placement: 'top',
    });
  });

};
